import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {esNormativaV2} from '../../../../utils/normativa.utils'

interface PropiedadesFilaDistritoDTE {
  distrito: any
  etiqueta?: string
}

export default function FilaDistritoDTE({distrito, etiqueta}: PropiedadesFilaDistritoDTE) {
  const {distritos, datosEmisor} = useSelector((state: State) => state.catalogos)

  const codigo = `${distrito ?? ''}`.trim()

  if (!esNormativaV2(datosEmisor)) return null

  const nombre = (distritos ?? []).find((dis: any) => dis?.codigo === codigo)?.valor

  return (
    <tr>
      <td>{etiqueta ?? 'Distrito'}:</td>
      <td>{nombre ? `${nombre}`.toUpperCase() : codigo || '--'}</td>
    </tr>
  )
}
